import React, { Component } from 'react';
import { Tag } from 'antd';
class ColorTag extends Component {
    constructor(props) {
        super(props);
    }
    render() {
        const { background, color } = this.props;
        return (<Tag color={background} style={{
            marginTop: 5,
        }}>
       <span style={{
            color,
        }}>
         {this.props.children}
       </span>
     </Tag>);
    }
}
export default ColorTag;
